//This is all in here so that we don't have any global variables
function initInteractiveMap() {
    var $html = $('html'),
        $mapResultsWrapper = $('.communityMap .map-results-wrapper'),
        $communityMap = $mapResultsWrapper.find('#communityMap'),
        $mapSearch = $('.communityMap .map-info .map-search-filters'),
        $mapResults = $mapResultsWrapper.find('.map-search-results'),
        $mapResultsListing = $mapResults.find('.map-results-listing'),
        $resetSearchBtn = $('.communityMap .map-search-actions .btn.reset-search'),
        $poiSelect = $mapSearch.find('.poi-select'),
        $keywordSearch = $mapSearch.find('input.keyword'),
        $noResults = $mapResults.find('.map-search-no-results'),
        $mapResultsDisplayStatus = $mapResultsWrapper.find('#map-results-display-status'),
        $featuredPois,
        initialized = false,
        initializedSearchable = false,
        poiCount = 0,
        poiMarkers = [],
        poiResultsMap = {},
        placesIdMap = {},
        keywordMarkers = [],
        placesRetryQueue = [],
        gMap,
        communityMarker,
        infowindow,
        lat,
        lng,
        poiUpdateThrottle,
        mapViewChangeThrottle,
        KEYWORD_SEARCH_POI_ID = 'keyword-search',
        GA_EVENT_CATEGORY = 'Community Map',
        GA_GENERIC_EVENT_LABEL = 'Map V1',
        POI_UPDATE_TIMEOUT = 500,
        MAP_VIEW_CHANGE_THROTTLE_TIME = 150,
        INITIAL_ZOOM_LEVEL = 14,
        GENERIC_MARKER_ICON_PATH = 'M12.7,0A12.7,12.7,0,0,0,0,12.7c0,7,12.7,24.1,12.7,24.1s12.7-17.09,12.7-24.1A12.7,12.7,0,0,0,12.7,0Zm0,16.58a4.4,4.4,0,1,1,4.41-4.4A4.4,4.4,0,0,1,12.7,16.58Z',
        DEFAULT_INFO_BUBBLE_OPTIONS = {
            arrowStyle: 0,
            backgroundClassName: 'info-bubble color-primary',
            backgroundColor: 'rgba(255,255,255,.75)',
            hideCloseButton: true,
            borderWidth: 0,
            shadowStyle: 3,
            borderColor: 'rgba(76, 76, 76, 0.65)',
            borderRadius: 0,
            arrowSize: 10,
            arrowPosition: '50%',
            minWidth: 160
        },
        RESULTS_DISPLAY_OPENED = 'Map results listing display opened. Press to close.',
        RESULTS_DISPLAY_CLOSED = 'Map results listing display closed. Press to open.';

    /**
     * Returns given point of interest's icon given the color in an svg format.
     * NOTE: Changing the scale will affect the point set in the anchor
     */
    function getPOIIcon(pointOfInterest, color, onlySVG) {
        var SVGPath,
            SVGViewBox,
            scale = 1,
            anchor = new google.maps.Point(13, 37);

        if (!!pointOfInterest) {
            switch (pointOfInterest.toLowerCase()) {
                case 'dog parks':
                    SVGPath = 'M0.4,0.5c0-0.2,0.2-0.4,0.3-0.5C0.9,0.1,1,0.1,1.1,0.2c3.6,2,7.2,4.1,10.8,6.1 c0.3,0.2,0.4,0.4,0.2,0.7c-0.2,0.4-0.4,0.3-0.7,0.2C7.8,5.1,4.2,3.1,0.6,1C0.5,0.9,0.4,0.7,0.4,0.5z M16.9,11.9 c-0.1,0.3-0.2,0.7-0.2,1.1c0,2.5,0,5.1,0,7.6c0,0.8-0.5,1.3-1.2,1.3c-0.7,0-1.2-0.5-1.2-1.3c0-1.2,0-2.4,0-3.6 c0-0.7,0.1-0.7-0.6-0.7c-1.9-0.1-3.8-0.4-5.6-0.9c-0.6-0.2-1.1-0.5-1.6-0.7c-0.1-0.1-0.4-0.1-0.5,0c-0.9,0.6-1.7,1.1-2.6,1.7 c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,1.2-0.5,2.5-0.8,3.7c-0.1,0.6-0.3,1.1-1,1.2c-0.6,0.1-1-0.3-1.3-0.8v-0.6c0.1-0.7,0.2-1.3,0.3-2 c0.2-1.1,0.3-2.2,0.5-3.3c0-0.2,0.1-0.4,0.3-0.6c0.7-0.7,1.3-1.6,1.4-2.6c0.1-0.4,0-0.8-0.1-1.1c-0.6-1.7-1.2-3.3-1.9-5 C0.4,5.6,0.5,5.3,0.7,5C1,4.8,1.4,4.8,1.7,5C1.8,5.1,1.9,5.2,2,5.3C2.5,6.2,3,7,3.5,7.9c0.1,0.3,0.4,0.5,0.7,0.4 c2.6,0,5.1-0.1,7.7-0.1c0.3,0,0.6,0.1,0.8,0.3c1.3,0.9,2.6,1.9,4,2.8C16.9,11.5,17,11.6,16.9,11.9z M22,7.8 c-0.1,0.2-0.2,0.5-0.3,0.8c-0.2,0.6-0.6,0.8-1.1,0.8c-0.7,0-1.4,0.1-2.1,0c-0.4,0-0.7,0.1-0.8,0.5c0,0.1-0.1,0.2-0.2,0.3 c-1.5-1.1-3-2.1-4.5-3.2c0.5-0.8,0.9-1.5,1.4-2.2c0.3-0.4,0.4-0.8,0.3-1.4c-0.1-0.5-0.2-1.1-0.2-1.6c0-0.5,0.1-0.7,0.5-0.8 c0.4-0.1,0.8,0.1,0.9,0.5c0.2,0.4,0.3,0.8,0.4,1.2c0.1,0.4,0.3,0.7,0.7,0.8C17.5,3.8,18,3.9,18,4.5c0,0.1,0.3,0.1,0.5,0.1 c0.1,0,0.3-0.1,0.4,0c0.8,0.4,1.6,0.9,2.4,1.3c0.2,0.1,0.4,0.4,0.6,0.6C22,7,22,7.4,22,7.8z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.3;
                    anchor = new google.maps.Point(10, 11);
                    break;
                case 'city parks':
                case 'parks':
                    SVGPath = 'M8.4,26c-3.3-0.2-6-1.4-7.8-4.4c-0.4-0.6-0.6-1.3-0.6-2.1c-0.1-2.2,0-4.4,0-6.6c0-0.3,0-0.7,0-1.2 l1.8,1.9c2.1,2.1,4,4.1,6,6.1c0.4,0.4,0.7,1,0.6,1.7C8.4,22.8,8.4,24.3,8.4,26z M22,16.4c-0.1,1.8-0.5,3.5-1.1,5.1 c-1.2,3-3.5,4.4-6.4,4.5c-1.5,0-3,0-4.5-0.1v-12c-0.3,0-0.6-0.1-0.9-0.1c-2.6-0.1-4.8-2.4-5-5.2C3.6,5.5,4.6,2.8,6,0.1L8.5,4 l2.7-3.6c0.6,1,1.1,1.8,1.6,2.7c0.5,0.9,0.9,0.9,1.5,0c0.6-0.9,1.2-2,1.8-3.1c1.1,1.4,1.8,3.2,1.9,5.1c0.1,1.3,0,2.7-0.3,4 c-0.7,3.3-2.1,4.6-5.1,5.1v7.1l9.1-9.4h0.3C22,13.4,22,14.9,22,16.4z';
                    SVGViewBox = '0 0 22 26';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 13);
                    break;
                case 'bus stations':
                case 'public transportation':
                    SVGPath = 'M14.2,0H7.7C3.4,0,0,1.7,0,5.9v17h1.1v2.3C1,25.6,1.3,25.9,1.7,26c0,0,0,0,0,0h1.8c0.4,0,0.8-0.4,0.8-0.8 v-2.3h13v2.3c0,0.4,0.4,0.8,0.8,0.8H20c0.5,0,0.8-0.4,0.9-0.8v-2.3H22v-17C22,1.7,18.6,0,14.2,0z M7.3,2.1h7.3v1.6H7.3V2.1z M3.3,19.5c-0.8,0-1.5-0.6-1.5-1.4s0.7-1.4,1.5-1.4s1.5,0.6,1.5,1.4C4.8,18.8,4.1,19.4,3.3,19.5C3.3,19.5,3.3,19.5,3.3,19.5z M15.7,19.2H6v-0.8h9.8L15.7,19.2z M6,17.4v-0.8h9.8v0.8H6z M18.5,19.4c-0.8,0-1.5-0.6-1.5-1.4c0-0.8,0.7-1.4,1.5-1.4 c0.8,0,1.5,0.6,1.5,1.4C20,18.8,19.4,19.4,18.5,19.4z M1.9,12.8v-7h18.2v7L1.9,12.8z';
                    SVGViewBox = '0 0 22 26';
                    anchor = new google.maps.Point(11, 13);
                    break;
                case 'subway stations':
                    SVGPath = 'M17.2,19.8c1.9-0.4,3.2-1.8,3.2-3.4V3.5c0-1.9-1.9-3.5-4.2-3.5H5.8C3.5,0,1.7,1.5,1.6,3.5v12.8 c0,1.6,1.3,3.1,3.2,3.4L0,26h2.8l3.5-4.3h9.5l3.5,4.4H22L17.2,19.8z M8.3,1.3C8.3,1,8.6,0.7,9,0.7H13c0.4,0,0.7,0.3,0.7,0.6v1 c0,0.3-0.3,0.6-0.7,0.6l0,0H9c-0.4,0-0.7-0.3-0.7-0.6v0C8.3,2.3,8.3,1.3,8.3,1.3z M5.7,17.9c-1,0-1.8-0.7-1.8-1.6 c0.1-0.9,1-1.5,2-1.5c0.9,0.1,1.6,0.7,1.7,1.5C7.6,17.2,6.7,17.9,5.7,17.9z M6,9.5c-1.1,0-2.1-0.7-2.1-1.7c0,0,0-0.1,0-0.1V5.4 C3.8,4.5,4.7,3.7,5.8,3.6c0.1,0,0.1,0,0.2,0H16c1.1,0,2.1,0.7,2.1,1.6c0,0.1,0,0.1,0,0.2v2.3c0,1-0.8,1.8-1.9,1.8 c-0.1,0-0.1,0-0.2,0L6,9.5L6,9.5z M14.4,16.3c0.1-0.9,1-1.5,2-1.5c0.9,0.1,1.6,0.7,1.7,1.5c0.1,0.9-0.7,1.6-1.7,1.7 s-1.9-0.6-2-1.5C14.4,16.5,14.4,16.4,14.4,16.3z';
                    SVGViewBox = '0 0 22 26';
                    scale = 1.1;
                    anchor = new google.maps.Point(11, 13);
                    break;
                case 'grocery stores':
                case 'shopping':
                    SVGPath = 'M21.6,0.1C21.4,0,21.3,0,21.1,0c-0.8,0.3-1.6,0.6-2.4,0.9c-0.3,0.2-0.6,0.4-0.8,0.7 c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0,0.1,0,0.1l-0.3,0l-2.4,0.2l-0.6,0.1l-3.1,0.3l-0.5,0.1L7.3,3.2L6.7,3.3l-3,0.3l-0.3,0l-0.3,0 L0.8,3.9L0,4v0.1l0.1,0.7l0.2,2l0.1,0.6l0.3,3.2l0.1,0.6l0,0.1c0.1,1.3,1.3,2.4,2.6,2.4h11.4v0.1c-0.1,0.3-0.6,1.1-1.6,1.3 c-0.2,0-0.4,0.1-0.5,0.1h-0.1c-0.7-0.1-11.4,0-11.4,0h0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0l0,0 c-0.1,0-0.1,0.1-0.1,0.1c-0.2,0.3-0.1,0.6-0.1,0.6c0,0.2,0.1,0.3,0.3,0.4c1.2,0,2.3,0,3.5,0c0,0,0,0-0.1,0h0 c-0.4,0.2-0.8,0.5-1.1,0.8c-0.2,0.1-0.3,0.3-0.4,0.4h0.2c0.7,0,1.3,0.4,1.6,1l0.3-0.3c1.1-0.8,2.4-1.3,3.7-1.3 c1.3,0,2.5,0.4,3.6,1.1c0,0,0.1,0,0.1,0.1l0.3,0.3c0.2-0.7,0.8-1.2,1.4-1.3h0.1c0,0-0.1-0.1-0.1-0.1l-0.3-0.3 c-0.2-0.2-0.4-0.4-0.7-0.5H13c0.3,0,0.6-0.1,0.9-0.2c0.1,0,1.5-0.6,2.1-2.2c0.1-0.2,0.1-0.3,0.1-0.5v0c0.1-0.2,0.1-0.5,0.2-0.8 c0.2-0.8,0.4-1.8,0.7-3.2l0-0.2l0,0c0.2-1,0.5-2,0.8-3.3l0,0l0.1-0.3C18.1,5,18.4,4,18.6,3c0-0.1,0-0.1,0.1-0.2 c0.1-0.1,0.2-0.4,0.5-0.5c0,0,0.1-0.1,0.1-0.1C19.4,2.1,19.6,2,19.8,2C20,2,20.2,2,20.4,1.9c0.4-0.1,0.8-0.2,1-0.3 c-0.1,0-0.1,0-0.1,0c0,0,0.6-0.1,0.7-0.6C22.1,0.7,21.9,0.4,21.6,0.1z M14.1,3.4l-0.4,2.4l-2.9,0.2L11,3.7L14.1,3.4z M13.2,9.7 l-2.7,0.2l0.3-3.2l2.9-0.2L13.2,9.7z M4,7.2L6.8,7v3.2l-2.6,0.2L4,7.2z M7.3,6.9l2.9-0.2L9.9,9.9l-2.6,0.2V6.9z M10.4,3.8 l-0.2,2.3L7.3,6.3V4.2L10.4,3.8z M6.7,4.2v2.2L3.9,6.6L3.8,4.5L6.7,4.2z M0.9,4.8l2.3-0.2l0.1,2L1.1,6.8L0.9,4.8z M1.2,7.4 l2.2-0.2l0.2,3.2l-2.1,0.1L1.2,7.4z M3.4,12.8c-0.9,0-1.7-0.7-1.8-1.6v-0.1l2-0.1l0.1,1.8H3.4z M4.2,12.8L4.1,11l2.6-0.2v2.1H4.2z M7.3,12.8v-2.1l2.5-0.2l-0.2,2.3L7.3,12.8L7.3,12.8z M10.2,12.8l0.2-2.3l2.7-0.2l-0.4,2.5L10.2,12.8z M13.2,12.8l0.4-2.6l2-0.1 c-0.2,0.9-0.4,1.8-0.6,2.7L13.2,12.8z M15.8,9.5L15.8,9.5l-2.1,0.1l0.5-3.2l2.3-0.2l0,0C16.3,7.3,16,8.4,15.8,9.5z M16.7,5.6 l-2.4,0.2l0.4-2.5l2.6-0.3C17.1,3.9,16.9,4.8,16.7,5.6z M2.7,18.3L2.7,18.3c-0.2,0-0.3,0-0.3,0c-0.6,0.1-1.2,0.5-1.4,1.2c0,0.1,0,0.1-0.1,0.1l0,0l0,0 c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.1,0.5c0,1,0.8,1.9,1.8,1.9c0.1,0,0.2,0,0.3,0c0.7-0.1,1.3-0.7,1.4-1.5c0-0.1,0-0.3,0-0.4 C4.4,19.1,3.6,18.3,2.7,18.3z M2.8,21.4H2.6c-0.7,0-1.2-0.6-1.2-1.3v-0.1c0-0.7,0.6-1.2,1.2-1.2c0.2,0,0.3,0,0.5,0.1 c0.3,0.1,0.5,0.4,0.6,0.7c0,0.1,0.1,0.2,0.1,0.3v0.1C3.8,20.8,3.4,21.3,2.8,21.4L2.8,21.4z M14.6,18L14.6,18c-0.2,0-0.3,0-0.3,0c-0.6,0.1-1.2,0.5-1.4,1.2c0,0.1-0.1,0.1-0.1,0.2 c0,0.2-0.1,0.3-0.1,0.5c0,1,0.8,1.9,1.8,1.9c0.1,0,0.2,0,0.3,0c0.7-0.1,1.3-0.7,1.4-1.5c0-0.1,0.1-0.3,0.1-0.4 C16.3,18.9,15.6,18,14.6,18z M14.7,21.1h-0.2c-0.7,0-1.2-0.6-1.2-1.3v-0.1c0-0.7,0.6-1.2,1.2-1.2c0.2,0,0.3,0,0.5,0.1 c0.3,0.1,0.5,0.4,0.6,0.7c0,0.1,0.1,0.2,0.1,0.3v0.1C15.7,20.5,15.3,21.1,14.7,21.1z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.3;
                    //Not sure why this one needs so much x adjustment
                    anchor = new google.maps.Point(10, 11);
                    break;
                case 'shopping malls':
                    SVGPath = 'M5.5,4.9C5.6,2,8.2-0.1,11.3,0c2.5,0.1,4.7,1.8,5.2,4.2c0.1,0.9,0.1,1.8,0.1,2.6 c0.1,0.8,0.3,1.5,0.4,2.3c0,0.4-0.1,0.8-0.4,1c-0.3,0.2-0.7,0.2-1,0c-0.3-0.3-0.4-0.7-0.3-1c0.2-1.5,0.3-3.1,0.2-4.6 c-0.3-2.2-2.4-3.8-4.8-3.6C8.3,1.1,6.5,3,6.5,5.2c0,0.4,0,0.9,0,1.3L6.2,6.6c0.2,0.9,0.4,1.7,0.6,2.6c0,0.3-0.1,0.7-0.4,0.9 c-0.3,0.2-0.6,0.2-0.9,0.1C5.2,10,5,9.6,5,9.2C5.1,7.8,5.3,6.4,5.5,4.9z M21.8,28H0.4c1.6-3.5,0.3-7,0.2-10.5S0.2,10.6,0,7.1h4.6 c-0.1,0.5-0.2,1-0.3,1.5c-0.4,0.8-0.2,1.7,0.6,2.2c0.7,0.5,1.6,0.5,2.3,0C7.8,10.2,8,9.3,7.6,8.6C7.4,8.1,7.3,7.6,7.2,7h7.6 c-0.1,0.5-0.2,1.1-0.4,1.6c-0.4,0.8-0.1,1.7,0.6,2.1c0.6,0.5,1.6,0.5,2.2,0c0.7-0.5,1-1.4,0.6-2.1c-0.2-0.5-0.3-1.1-0.4-1.6H22 c-0.1,1.8-0.2,3.6-0.3,5.3c-0.3,4.3-0.6,8.6-0.8,12.9C21.1,26.2,21.4,27.1,21.8,28z';
                    SVGViewBox = '0 0 22 28';
                    scale = 1.1;
                    anchor = new google.maps.Point(11, 14);
                    break;
                case 'department stores':
                    SVGPath = 'M4.5,13.2c-0.3,0-0.3,0.2-0.3,0.4c0,1.7,0,3.5,0,5.2c0,0.4,0.1,0.5,0.5,0.5c2,0,4,0,6,0H11v-6 c-0.1,0-0.2,0-0.3,0L4.5,13.2zM1.5,0.6c0.1-0.4,0.6-0.7,1-0.6h17c0.8,0,1.1,0.3,1.1,1.1c0.1,1.5-0.5,1.6-1.5,1.6 c-5.4,0-10.9,0-16.3,0c-1.1,0-1.3-0.3-1.3-1.3C1.4,1.1,1.5,0.9,1.5,0.6z M22,10.3c-0.4,0.4-1,0.4-1.4,0.1v10.7 c0,0.4-0.3,0.8-0.7,0.9c-0.7,0-1.3,0-2,0v-8.8c-1.3,0-2.6,0-3.8,0c-0.4,0-0.5,0.1-0.5,0.5c0,2.6,0,5.2,0,7.8V22h-11 c-0.8,0-1.2-0.3-1.2-1.2V10.4c-0.4,0.3-1.1,0.2-1.4-0.2C0.1,10.1,0,10.1,0,10V9.5c0.1-0.1,0.1-0.3,0.2-0.4C0.5,8,0.9,7,1.3,5.9 c0.1-0.4,0.2-0.8,0.2-1.2c0-1,0.3-1.3,1.3-1.3h16.6c0.2,0,0.3,0,0.5,0c0.4,0,0.8,0.4,0.8,0.8c0,0.9,0.2,1.8,0.6,2.6 c0.3,0.7,0.5,1.5,0.8,2.2C22,9.6,22,9.9,22,10.3z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.25;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'restaurants':
                    SVGPath = 'M11,0C17.1,0,22,5,22,11c0,4-2.2,7.7-5.7,9.6v-0.4l0,0c0-0.5,0-1,0-1.4c0-1.4-0.1-3,0-4.4 c0-0.7,0.4-0.9,0.9-1.3c0.5-0.3,0.7-0.8,0.8-1.4c0.1-0.7,0-1.4-0.1-2c-0.1-0.7-0.1-1.4-0.2-2c-0.1-1.3-0.3-2.7-0.3-4.1H17 c0,2.2,0,4.4,0,6.5c0,0.3,0,0.7-0.3,0.7c-0.3,0-0.3-0.3-0.3-0.6c0-2.2,0-4.4,0-6.6H16v6.7c0,0.4,0,0.6-0.5,0.5 c-0.2-0.3-0.2-0.3-0.2-0.8V3.5h-0.3v5.8c0,0.4,0.2,1.7-0.5,1.4c-0.2-0.1-0.2-0.4-0.2-0.8V3.5h-0.4c-0.1,1.4-0.7,7-0.6,8.1 c0,0.3,0.1,0.6,0.2,0.8c0.3,0.4,0.7,0.8,1.1,1.1c0.5,0.4,0.4,2.2,0.4,3c0,1.1,0,2.4-0.1,3.9v0.8c-2.2,0.9-4.6,1-6.9,0.5l0-0.7l0,0 c-0.1-1.8-0.1-3.4-0.1-4.6c0-0.8,0-1.6,0-2.4c0-1.1,1.5-0.8,2.5-2.4c0.3-0.6,0.5-1.3,0.5-2c-0.1-1.6-0.6-3.2-1.5-4.6 C9.2,4.5,8.8,4,8.3,3.7c-0.3-0.2-0.7-0.2-1-0.1C6.6,3.7,6.1,4.1,5.8,4.6c-0.3,0.5-0.7,1-0.9,1.5c-0.8,1.7-1.4,4.1-0.1,5.7 c0.4,0.5,0.9,0.8,1.4,1.1c0.3,0.1,0.5,0.3,0.7,0.5C7,13.9,7.1,14.3,7,14.6c0,1.5,0,3.8-0.1,5.9v0.2v0.5l0,0l0,0 c-5.7-2.3-8.4-8.7-6.1-14.3C2.5,2.7,6.5,0,11,0z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.3;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'coffee shops':
                    SVGPath = 'M21.7,11.2c-0.4-0.6-1.2-0.9-1.9-0.8h-1.3c0-0.4,0-0.9,0-1.3H0.5c0,0-0.4,3.2,1.1,5.8 c0.6,1.1,1.4,2,2.4,2.8C4.9,18.5,6,19,7.1,19h4.7c1.1-0.1,2.2-0.5,3-1.3c0.3-0.3,0.6-0.6,0.9-0.8c4.7-0.2,5.9-3.3,6.1-3.7 C22.1,12.5,22,11.8,21.7,11.2L21.7,11.2z M20.3,12.6L20.3,12.6c0,0.1-0.6,1.9-3.2,2.6l0.2-0.3c0.5-0.9,0.9-1.9,1-3h1.4 c0.4,0,0.5,0.1,0.6,0.1C20.5,12.2,20.4,12.4,20.3,12.6L20.3,12.6z M18.9,20.1H0.1C-1,21.3,6.4,22,6.4,22h6.3 C12.7,22,19.8,21.3,18.9,20.1 M11.2,7.8c0,0.1-0.2,0.1-0.3,0.1c-2.3-1.3-1.7-3.2-0.2-4.6c1.1-1,2-1.5,2-3.2C12.6,0,13,0,13,0 C15.8,3.8,9.6,3.9,11.2,7.8 M7.1,7.8c0,0.1-0.2,0.1-0.3,0.1C4.5,6.5,5.1,4.7,6.6,3.3c1.1-1,2-1.5,2-3.2C8.5,0,8.9,0,8.9,0 C11.7,3.7,5.5,3.9,7.1,7.8';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.3;
                    anchor = new google.maps.Point(10, 11);
                    break;
                case 'schools':
                case 'elementary schools':
                case 'schools/universities':
                    SVGPath = 'M12.6,3.3c-0.9-0.1-1.9-0.1-2.8,0C9.5,3.4,9.3,3.7,9.2,4c0,0.2,0.4,0.6,0.6,0.6 c0.5,0.1,0.9,0.1,1.4,0c0.5,0,0.9,0,1.4,0c0.3,0,0.6-0.4,0.6-0.6C13.2,3.7,12.9,3.4,12.6,3.3zM2.8,15.1C0.5,11.5-0.4,7.2,0.2,2.9c0.1,0,0.2-0.1,0.3,0c1.9,0.3,1.8,0.3,1.9,2.2 C2.4,7,2.7,9.2,2.8,11.3C2.9,12.5,2.8,13.8,2.8,15.1z M0.3,1.4C1.5,0.9,2.8,0.4,4,0c1.2-0.2,2.7,1,3.2,2.5L4.7,4.2 C3.8,2.4,2.1,1.9,0.3,1.4z M17.9,18c0.3,1.9-1.1,3.7-3.1,4c-0.3,0-0.6,0-0.9,0c-2.1,0-4.1-0.1-6.1,0c-1.8,0-3.3-1.4-3.5-3.2 c0-3.7,0-7.5,0-11.2c0.1-1.6,1.4-3,3.1-3.2l0.8-0.1c0.3-1.4,0.7-1.8,2.1-1.8H12c1.6,0,1.9,0.2,2.4,1.8C17.1,4.8,18,5.9,18,8.7 C17.9,11.8,17.9,14.9,17.9,18L17.9,18z M17.3,4.2l-2.5-1.6c0.3-1.6,1.9-2.7,3.5-2.4c0.2,0,0.4,0.1,0.6,0.2l3,1.2 C20,1.9,18.3,2.4,17.3,4.2z M19.2,15.1h-0.3c0.3-2.4,0.6-4.7,0.8-7c0.1-1.3,0.1-2.6,0-3.8c0-0.7,0.1-0.9,0.7-1.1 C21,3.1,21.3,3,21.8,2.9C22.6,6.8,21.3,13,19.2,15.1z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'middle schools':
                case 'high schools':
                case 'colleges':
                    SVGPath = 'M6.4,21.9c-1.7,0-3.5,0-5.2,0c0-0.2,0-0.4,0-0.6c0-2.1,0-4.1,0-6.2c0-0.4,0.1-0.6,0.6-0.6 c1.6,0,3.2,0,4.7,0c0.2,0,0.3,0,0.5,0c0,0.2,0,0.3,0,0.5c0,2.1,0,4.2,0,6.2C7,21.8,6.8,21.9,6.4,21.9zM5.9,13.4H0v-1.6c0.2,0,0.3,0,0.5,0c2,0,4,0,5.9,0C6.9,11.8,7,12,7,12.4C7,13.4,7,13.4,5.9,13.4zM20.2,21.7c0,0.1,0,0.1,0,0.3c-1.7,0-3.3,0-4.9,0c-0.1,0-0.3-0.2-0.3-0.4c0-0.6,0-1.2,0-1.9h-1.8 v2.2H8.1c0-0.1,0-0.3,0-0.5c0-3.5,0-7,0-10.4c0-0.3,0.1-0.6,0.4-0.7C10.2,9.1,12,8,13.7,6.9c0.2-0.2,0.6-0.2,0.8,0 c1.8,1.1,3.6,2.3,5.3,3.4c0.2,0.1,0.3,0.4,0.3,0.6C20.2,14.5,20.2,18.1,20.2,21.7zM20.3,9.5c-1.9-1.3-3.9-2.5-5.9-3.8c-0.2-0.2-0.6-0.2-0.8,0c-2.1,1.4-4.2,2.8-6.4,4.2 c-0.3-0.5-0.6-1-1-1.5L6.7,8c2.1-1.3,4.2-2.7,6.3-4c0.3-0.2,0.5-0.5,0.5-0.9c0-1,0-2,0-3.1h0.9c-0.1,0.8,0.5,0.7,1.1,0.7 c0.7,0,1.3-0.2,2.1-0.3c0,0.7,0,1.3,0,2c0,0.1-0.3,0.3-0.4,0.3c-0.8,0.1-1.7,0.2-2.6,0.3c-0.2,0.4,0,0.8,0.4,1 c2.1,1.3,4.2,2.7,6.3,4c0.2,0.1,0.3,0.2,0.6,0.4c-0.4,0.5-0.7,0.9-1.1,1.4L20.3,9.5zM26.9,21.7c0,0.1,0,0.1-0.1,0.2h-5.2c-0.3,0-0.5,0-0.5-0.4c0-2.2,0-4.4,0-6.5 c0-0.3,0.1-0.4,0.4-0.4c1.7,0,3.3,0,5,0c0.2,0,0.3,0.2,0.4,0.3C26.9,17.2,26.9,19.5,26.9,21.7zM28,13.4h-0.5c-1.9,0-3.8,0-5.7,0c-0.5,0-0.6-0.1-0.6-0.6c0-1,0-1,1.1-1H28 C28,12.4,28,12.9,28,13.4z';
                    SVGViewBox = '0 0 28 22';
                    scale = 1.2;
                    anchor = new google.maps.Point(14, 11);
                    break;
                case 'universities':
                    SVGPath = 'M4.7,22.2c0.1,0,0.2-0.1,0.2-0.2l0,0v-9.2c0-0.1-0.1-0.2-0.2-0.2H2.8c-0.1,0-0.2,0.1-0.2,0.2V22 c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0H4.7zM19.2,22.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0v-9.2c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9 c-0.1,0-0.2,0.1-0.2,0.2V22c0,0.1,0.1,0.2,0.2,0.2l0,0H19.2zM15.6,22.2c0.1,0,0.2-0.1,0.2-0.2l0,0v-9.2c0-0.1-0.1-0.2-0.2-0.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2V22 c0,0.1,0.1,0.2,0.2,0.2l0,0H15.6zM11.9,22.2c0.1,0,0.2-0.1,0.2-0.2l0,0v-9.2c0-0.1-0.1-0.2-0.2-0.2H10c-0.1,0-0.2,0.1-0.2,0.2V22 c0,0.1,0.1,0.2,0.2,0.2l0,0H11.9zM8.3,22.2c0.1,0,0.2-0.1,0.2-0.2l0,0v-9.2c0-0.1-0.1-0.2-0.2-0.2H6.4c-0.1,0-0.2,0.1-0.2,0.2V22 c0,0.1,0.1,0.2,0.2,0.2h0H8.3zM21.8,24h-1.1v-1.2c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0H1.5c-0.1,0-0.2,0.1-0.2,0.2l0,0V24H0.2 C0.1,24,0,24.1,0,24.2c0,0,0,0,0,0v1.6C0,25.9,0.1,26,0.2,26c0,0,0,0,0,0h21.6c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0v-1.6 C22,24.1,21.9,24.1,21.8,24zM21.7,10.7L11.3,5.3c0,0,0,0-0.1,0V3.1h3.9c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0V0.4 c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0h-3.9V0.1c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0h-0.3c-0.1,0-0.1,0-0.2,0.1c0,0,0,0,0,0v5.1 c0,0,0,0-0.1,0L0.3,10.8C0.1,10.8,0,11,0,11.2v0.6c0,0.2,0.2,0.4,0.4,0.4h21.2c0.2,0,0.4-0.2,0.4-0.4l0,0v-0.6 C22,11,21.9,10.8,21.7,10.7z';
                    SVGViewBox = '0 0 22 26';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 13);
                    break;
                case 'hospitals':
                    SVGPath = 'M21.8,11L11.4,0.2c-0.2-0.2-0.5-0.2-0.7,0L0.2,11C0,11.1,0,11.3,0,11.5c0.1,0.2,0.3,0.3,0.5,0.3 h2.3v9.7C2.8,21.8,3,22,3.3,22c0,0,0,0,0,0h15.4c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0v-9.7h2.2c0.2,0,0.4-0.1,0.5-0.3 C22,11.3,22,11.1,21.8,11z M16.1,15.7h-3.3v3.1H9.1v-3.1H5.9v-3.6h3.2V9.1h3.7v3.1h3.2L16.1,15.7L16.1,15.7z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.4;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'movie theaters':
                    SVGPath = 'M23.9,0H2.1C0.9,0,0,1.1,0,2.3c0,0,0,0,0,0v17.3C0,20.9,0.9,22,2.1,22l0,0h21.9c1.1,0,2.1-1.1,2.1-2.3l0,0 V2.3C26,1.1,25.1,0,23.9,0C23.9,0,23.9,0,23.9,0z M4.7,17.9c0,0.2-0.1,0.4-0.3,0.4h0H1.7c-0.2,0-0.3-0.2-0.3-0.4l0,0l0,0v-2.1 c0-0.2,0.1-0.4,0.3-0.4c0,0,0,0,0,0h2.6c0.2,0,0.3,0.2,0.3,0.4l0,0l0,0L4.7,17.9z M4.7,12c0,0.2-0.1,0.4-0.3,0.4h0H1.7 c-0.2,0-0.3-0.2-0.3-0.4l0,0l0,0V10c0-0.2,0.1-0.4,0.3-0.4c0,0,0,0,0,0h2.6c0.2,0,0.3,0.2,0.3,0.4l0,0l0,0L4.7,12z M4.7,6.2 c0,0.2-0.1,0.4-0.3,0.4h0H1.7c-0.2,0-0.3-0.2-0.3-0.4c0,0,0,0,0,0l0,0V4.1c0-0.2,0.1-0.3,0.3-0.3h2.6c0.2,0,0.3,0.2,0.3,0.3l0,0 L4.7,6.2z M16.2,11.8l-5.6,3.8c-0.4,0.3-0.9,0.1-1.1-0.3c-0.1-0.1-0.1-0.3-0.1-0.5V7.2c0-0.5,0.4-0.9,0.8-0.9c0.1,0,0.3,0,0.4,0.1 l5.6,3.8c0.4,0.3,0.5,0.8,0.3,1.2C16.4,11.6,16.3,11.7,16.2,11.8L16.2,11.8z M24.6,17.9c0,0.2-0.1,0.4-0.3,0.4l0,0h-2.6 c-0.2,0-0.3-0.2-0.3-0.4l0,0l0,0v-2.1c0-0.2,0.1-0.4,0.3-0.4l0,0h2.6c0.2,0,0.3,0.2,0.3,0.4l0,0l0,0L24.6,17.9z M24.6,12 c0,0.2-0.1,0.4-0.3,0.4l0,0h-2.6c-0.2,0-0.3-0.2-0.3-0.4l0,0l0,0V10c0-0.2,0.1-0.4,0.3-0.4l0,0h2.6c0.2,0,0.3,0.2,0.3,0.4v0l0,0 L24.6,12z M24.6,6.2c0,0.2-0.1,0.4-0.3,0.4l0,0h-2.6c-0.2,0-0.3-0.2-0.3-0.4v0l0,0V4.1c0-0.2,0.1-0.4,0.3-0.4l0,0h2.6 c0.2,0,0.3,0.2,0.3,0.4v0l0,0L24.6,6.2z';
                    SVGViewBox = '0 0 26 22';
                    scale = 1.2;
                    anchor = new google.maps.Point(13, 11);
                    break;
                case 'arenas':
                    SVGPath = 'M11,0c3.4,0,6.2,2.3,6.3,5v1.6H4.7V5C4.8,2.3,7.6,0,11,0z M17.3,7.6v0.8H4.7V7.6H17.3z M17.3,9.6 v0.8H4.7V9.5L17.3,9.6z M17.3,11.4v2.3c-0.1,2.7-2.9,4.9-6.3,5c-3.5,0-6.3-2.2-6.3-5v-2.4L17.3,11.4z M9.5,22.7C1,22,0,15.8,0,10.1c0-1,2.6-1,2.8-0.1c0.1,4.6,0.1,10.5,8.2,10.5s8.2-5.9,8.2-10.5 c0.3-0.9,2.8-0.8,2.8,0.1c0,5.6-1,11.8-9.5,12.5v3.1h4.4c0.8-0.1,1.5,0.4,1.5,1c0.1,0.6-0.5,1.2-1.3,1.2c-0.1,0-0.2,0-0.3,0H5.1 c-0.8-0.1-1.3-0.6-1.3-1.2c0.1-0.5,0.6-1,1.3-1h4.4V22.7z';
                    SVGViewBox = '0 0 22 28';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 14);
                    break;
                case 'stadiums':
                    SVGPath = 'M0,15.9c0,1.8,0.3,3.6,0.9,5.2C2.6,21.7,4.3,22,6.1,22c0.5,0,1,0,1.6-0.1l-7.6-7.6 C0,14.8,0,15.3,0,15.9z M21.1,0.9C19.4,0.3,17.7,0,15.9,0c-0.5,0-1,0-1.6,0.1l7.6,7.6C22,7.2,22,6.7,22,6.1 C22,4.3,21.7,2.6,21.1,0.9zM0.4,12.3l9.3,9.3c5.9-1.4,10.5-6,11.9-11.9l-9.3-9.3C6.4,1.8,1.8,6.4,0.4,12.3z M13.3,8l1.5-1.5 l0.7,0.7L14,8.7l0.9,0.9l-0.7,0.7l-0.9-0.9L11.7,11l0.9,0.9l-0.7,0.7L11,11.7l-1.8,1.8l0.9,0.9l-0.7,0.7l-0.9-0.9l-1.4,1.4 l-0.7-0.7l1.4-1.4L7,12.6l0.7-0.7l0.9,0.9l1.8-1.8l-0.8-0.8l0.7-0.7l0.8,0.8l1.7-1.7l-0.9-0.9l0.7-0.7L13.3,8z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'museums':
                    SVGPath = 'M19.7,0H2.2C1,0,0,1.1,0,2.5c0,0,0,0,0,0v16.8C0,20.8,1,22,2.2,22c0,0,0,0,0,0h17.6 c1.2,0,2.2-1.1,2.2-2.5c0,0,0,0,0,0V2.6C22,1.1,21,0,19.7,0z M17,3.9c0.9,0,1.7,0.9,1.7,1.9S18,7.8,17,7.8c-0.9,0-1.7-0.9-1.7-1.9 S16.1,3.9,17,3.9L17,3.9z M2.7,16.2l6-10.3l4,6.9l2-3l4.4,6.5L2.7,16.2z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.2;
                    anchor = new google.maps.Point(11, 11);
                    break;
                case 'entertainment':
                    SVGPath = 'M13.1,1.5L9.2,0.1c-0.9-0.3-1.8,0.1-2.1,1c0,0,0,0,0,0L6.9,1.5H8l0-0.1C8.1,1,8.5,0.8,8.8,1 c0,0,0,0,0,0l1.4,0.5H13.1z M18.9,3.5l2,0.7c0.9,0.3,1.3,1.2,1,2c0,0,0,0,0,0l-3,8v-2.8L21,6c0.1-0.3-0.1-0.7-0.4-0.8c0,0,0,0,0,0 l-1.7-0.6L18.9,3.5z M15.1,24.5l-0.2,0.4c-0.3,0.8-1.3,1.3-2.1,1c0,0,0,0,0,0l-3.9-1.4h2.9l1.4,0.5c0.3,0.1,0.7,0,0.8-0.4 c0,0,0,0,0,0l0-0.1H15.1z M3.1,22.5l-2-0.7c-0.9-0.3-1.3-1.2-1-2c0,0,0,0,0,0l3-8.1v2.8L1,20c-0.1,0.3,0.1,0.7,0.4,0.8 c0,0,0,0,0,0l1.7,0.6L3.1,22.5z M4.7,2.4c-0.4,0-0.7,0.3-0.7,0.6v19.8c0,0.4,0.3,0.6,0.7,0.6h12.5c0.4,0,0.7-0.3,0.7-0.6V3.1 c0-0.4-0.3-0.6-0.7-0.6L4.7,2.4z M4.7,1.5h12.5c0.9,0,1.6,0.7,1.6,1.6v0v19.9c0,0.9-0.7,1.6-1.6,1.6H4.7c-0.9,0-1.6-0.7-1.6-1.6 c0,0,0,0,0,0V3.1C3.1,2.2,3.8,1.5,4.7,1.5C4.7,1.5,4.7,1.5,4.7,1.5z M10.3,11.7c0.2,0.2,0.5,0.4,0.7,0.5c0.7,0.3,1.3,0.6,1.9,1.1c0.4,0.4,0.6,0.9,0.6,1.5 c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.3-0.8,0.6-1.3,0.6v0.9c0,0.1-0.1,0.2-0.2,0.2h-0.8c-0.1,0-0.2-0.1-0.2-0.2v-0.9 c-0.6-0.1-1.2-0.3-1.7-0.7c-0.4-0.4-0.7-1-0.7-1.6c0-0.1,0.1-0.3,0.3-0.3c0,0,0,0,0,0h1.3c0.1,0,0.2,0.1,0.3,0.2 c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.2c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.5-0.2-0.7 c-0.2-0.2-0.5-0.4-0.7-0.5c-0.7-0.2-1.3-0.6-1.9-1c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.5,0.2-1.1,0.6-1.5C9.3,9.3,9.8,9.1,10.4,9V8 c0-0.1,0.1-0.2,0.2-0.2l0,0h0.8c0.1,0,0.2,0.1,0.2,0.2l0,0v1c1.1,0.2,1.9,1.1,1.9,2.2c0,0.1-0.1,0.3-0.2,0.3c0,0,0,0,0,0h-1.4 c-0.1,0-0.2-0.1-0.3-0.2c0-0.2-0.1-0.5-0.2-0.6c-0.1-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.2-0.2,0.4-0.2,0.6 C10.1,11.4,10.2,11.6,10.3,11.7z';
                    SVGViewBox = '0 0 22 26';
                    break;
                case 'laundromats':
                    SVGPath = 'M8.7,21.7c-2.6,0-5.2,0-7.8,0c-0.4,0-0.4,0-0.4-0.4c0-3.8,0-7.6,0-11.4c0-1.4,0-2.7,0-4.1 c0-0.2,0-0.5,0.1-0.7c0.1-0.4,0.5-0.5,0.9-0.5c3.3,0,6.7,0,10,0c1.5,0,3,0,4.5,0c0.6,0,0.9,0.2,0.9,0.8c0,0.9,0,1.9,0,2.8 c0,1.9,0,3.9,0,5.8c0,1.8,0,3.6,0,5.4c0,0.6,0,1.2,0,1.8c0,0.3-0.1,0.3-0.3,0.3C14,21.7,11.4,21.7,8.7,21.7z M8.8,7.1 C5.7,7,3.2,9.6,3.2,12.6c0,3.1,2.5,5.5,5.5,5.6c3.2,0.1,5.7-2.5,5.7-5.6C14.4,9.6,11.8,7,8.8,7.1z M0.6,3.5c0-0.9,0-1.7,0-2.6c0-0.3,0.3-0.6,0.6-0.6c0.1,0,0.2,0,0.3,0c4.8,0,9.6,0,14.4,0c0.5,0,1,0.2,1,0.9c0,0.7,0,1.4,0,2.1c0,0.2-0.1,0.3-0.3,0.3c-5.3,0-10.6,0-15.9,0C0.8,3.5,0.7,3.5,0.6,3.5z M6.1,1.9C6.2,1.4,5.8,1,5.3,1c-0.5,0-0.9,0.4-0.9,0.9c0,0.4,0.4,0.9,0.9,0.9C5.7,2.8,6.1,2.4,6.1,1.9z M3.7,1.9c0-0.5-0.4-0.9-0.9-0.9C2.4,1,2,1.4,2,1.9c0,0.5,0.4,0.9,0.9,0.9C3.3,2.8,3.8,2.3,3.7,1.9zM4.300000000000001,12.7a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0';
                    SVGViewBox = '0 0 17.5 22';
                    scale = 1.3;
                    anchor = new google.maps.Point(8.7, 11);
                    break;
                case 'beaches':
                    SVGPath = 'M78.7,140.9c0.1-1.8-0.2-3.8,0.5-5.4c3.3-7.4,6.9-14.6,10.7-22.6c-5.3,0-9.9-0.1-14.5,0c-3,0.1-4-1.1-4.2-4.1 c-0.4-10-0.5-10,9.6-10c20.8,0,41.6-0.1,62.4,0.1c3.8,0,6.1-0.6,7.5-4.5c1.4-4,3.5-7.9,5.8-11.5c1-1.6,3.4-3.2,5.2-3.2 c11-0.3,22-0.3,33-0.1c3.3,0.1,5.1-0.9,6.5-4c3.2-7.1,7.2-13.9,10.2-21.1c1.9-4.6,4.5-6,9.4-5.8c8.9,0.4,8.9,0.1,5,8.2 c-8.4,17.5-17,35-25.2,52.6c-0.9,1.8-0.8,4.8,0.1,6.7c2.9,6.3,6.4,12.4,9.5,18.6c0.9,1.8,1,4,1.4,6.1c-4.7,0-9.3,0-14,0 c-4-8.4-7.8-16.8-12-25.1c-0.7-1.4-3.2-2.8-4.8-2.8c-23.8-0.2-47.6-0.1-71.4-0.2c-3.2,0-4.6,1.2-5.9,4 c-3.8,8.1-7.9,16.1-11.8,24.1C87.4,140.9,83,140.9,78.7,140.9z M160.9,98.9c7.6,0,14.7,0,21.7,0c8.4,0,8.7-0.3,10.8-8.9 c-6.8,0-13.6,0-20.3,0C164.4,90,164.4,90,160.9,98.9z M118.7,140.1c-2.7-3-3.2-6.3-2.1-10.1c1-3.5,1.5-7.1,2.3-11c4.1,0.8,7.7,1.6,11.9,2.4c-1,5.1-1.7,10.2-3.3,15.1 c-0.6,1.8-3.2,2.9-4.9,4.4C121.3,140.7,120,140.4,118.7,140.1z M167.7-79.5c3.9,4.4,4,6.6,0.6,15.8c-3.6-0.7-7.3-1.5-11.2-2.3c1.1-5.5,0.2-11.6,6.8-14.3C165-80,166.4-79.8,167.7-79.5z M225.6,20.5c-18.8-17.6-26.7-19.2-45.8-9.6c-7.6-9-16.7-15.8-28.7-18.2c-11.8-2.4-22.8,0-33.5,5.6 C105.3-18,90.2-21,71.2-10.3c0.8-3.8,1-6.5,1.9-8.9c5.6-15.8,16.7-26.5,31.6-33.7c40.5-19.4,94.2-3.6,115.5,34 c6.2,10.9,8.7,22.6,6.7,35C226.6,17.4,226.1,18.6,225.6,20.5z M136.3,93.5c-4-0.8-7.5-1.5-11.3-2.3c0.2-1.5,0.2-2.8,0.4-4c5.7-28,11.6-56,17-84.1c1-5.3,3.9-4.2,7.2-3.6 c3.2,0.6,6.1,0.8,5.1,5.8c-6,28.5-11.7,57-17.6,85.5C137,91.5,136.7,92.3,136.3,93.5z M3.4,21.6c0-0.2,0-0.4,0.1-0.6c0.4-0.8,0.7-1.5,1.1-2.3c-0.6,0-1.1,0-1.6,0c-0.3,0-0.4-0.1-0.4-0.4 c0-1-0.1-1,1-1c2.2,0,4.5,0,6.7,0c0.4,0,0.7-0.1,0.8-0.5c0.2-0.4,0.4-0.8,0.6-1.2c0.1-0.2,0.4-0.3,0.6-0.3c1.2,0,2.4,0,3.5,0 c0.4,0,0.5-0.1,0.7-0.4c0.3-0.7,0.8-1.4,1.1-2.1c0.2-0.5,0.5-0.6,1-0.6c1,0,1,0,0.5,0.8c-0.9,1.8-1.8,3.6-2.7,5.4 c-0.1,0.2-0.1,0.5,0,0.7c0.3,0.6,0.7,1.3,1,1.9c0.1,0.2,0.1,0.4,0.2,0.6c-0.5,0-1,0-1.5,0c-0.4-0.9-0.8-1.7-1.3-2.6 c-0.1-0.1-0.3-0.3-0.5-0.3c-2.6,0-5.1,0-7.7,0c-0.3,0-0.5,0.1-0.6,0.4c-0.4,0.8-0.8,1.6-1.3,2.5C4.3,21.6,3.8,21.6,3.4,21.6z M12.2,17.3c0.8,0,1.6,0,2.3,0c0.9,0,0.9,0,1.2-0.9c-0.7,0-1.5,0-2.2,0C12.6,16.4,12.6,16.4,12.2,17.3z M7.7,21.5c-0.3-0.3-0.3-0.6-0.2-1c0.1-0.4,0.2-0.7,0.2-1.1c0.4,0.1,0.8,0.2,1.3,0.2c-0.1,0.5-0.2,1-0.4,1.5 c-0.1,0.2-0.3,0.3-0.5,0.4C7.9,21.6,7.8,21.5,7.7,21.5z M12.8,0.4c0.4,0.5,0.4,0.7,0.1,1.6c-0.4-0.1-0.8-0.2-1.2-0.2c0.1-0.6,0-1.2,0.7-1.5 C12.6,0.3,12.7,0.4,12.8,0.4z M19.1,10.6c-2-1.8-2.9-2-4.9-1c-0.8-0.9-1.8-1.6-3.1-1.9c-1.3-0.2-2.4,0-3.6,0.6c-1.3-1.6-2.9-2-5-0.9 c0.1-0.4,0.1-0.7,0.2-0.9c0.6-1.6,1.8-2.7,3.4-3.4c4.3-2,10.1-0.4,12.4,3.5c0.7,1.1,0.9,2.3,0.7,3.6 C19.2,10.3,19.2,10.4,19.1,10.6z M11,8.4c-0.4-0.1-0.7-0.2-0.8,0.4c-0.5,2.5-1.1,5.1-1.6,7.6c0.4,0,0.9,0,1.3,0c0.5-2.4,1-4.9,1.6-7.3 C11.6,8.5,11.3,8.5,11,8.4z';
                    SVGViewBox = '0 0 22 22';
                    scale = 0.18;
                    anchor = new google.maps.Point(180, 180);
                    break;
                case 'military bases':
                    SVGPath = 'M2.2,20.5c0-1.5,0-6,0-7.5c0-0.3,0.2-0.5,0.5-0.5h16.5c0.3,0,0.5,0.2,0.5,0.5c0,1.5,0,6,0,7.5 c0,0.3-0.2,0.5-0.5,0.5h-5c-0.3,0-0.5-0.2-0.5-0.5V18c0-0.3-0.2-0.5-0.5-0.5H8.7c-0.3,0-0.5,0.2-0.5,0.5v2.5C8.2,20.8,8,21,7.7,21 H2.8C2.5,21,2.2,20.8,2.2,20.5z M10.6,6.9c0-2.2,0-4.4,0-6.6c0.3,0,0.5,0,0.7,0c0,0.2,0,0.4,0,0.5c0.4-0.1,0.7-0.2,1.1-0.3 c0.4-0.1,0.9-0.1,1.3,0c0.4,0.1,0.9,0.2,1.3,0.4C15.5,1,16,1.1,16.4,0.9c0,0.1,0,0.1,0,0.2c0,0.9,0,1.8,0,2.7c0,0.2,0,0.2-0.2,0.3 c-0.4,0.1-0.9,0.1-1.3,0c-0.4-0.1-0.7-0.2-1.1-0.3c-0.6-0.2-1.2-0.2-1.8,0.1c-0.2,0.1-0.4,0.1-0.6,0.2c0,0-0.1,0.1-0.1,0.1 c0,0.9,0,1.8,0,2.6c0,0.1,0.1,0.1,0.2,0.1C12.3,7,13,7.2,13.6,7.6c1.2,0.7,2,1.7,2.4,3.1c0,0.1,0,0.1,0,0.2 c0.6,0.1,0.9,0.3,0.9,0.8c-3.9,0-7.8,0-11.6,0c0-0.4,0.2-0.7,0.6-0.7C6,10.8,6,10.8,6,10.6C6.5,9.1,7.4,8,8.9,7.3 c0.5-0.2,1-0.3,1.5-0.4C10.5,6.9,10.5,6.9,10.6,6.9z';
                    SVGViewBox = '0 0 22 22';
                    scale = 1.3;
                    anchor = new google.maps.Point(11, 11);
                    break;
                default:
                    SVGPath = GENERIC_MARKER_ICON_PATH;
                    SVGViewBox = '0 0 25.39 36.79';
                    break;
            }
        } else {
            SVGPath = GENERIC_MARKER_ICON_PATH;
            SVGViewBox = '0 0 25.39 36.79';
        }

        if (!onlySVG) {
            return {
                anchor: anchor,
                path: SVGPath,
                fillColor: color,
                fillOpacity: 1,
                strokeWeight: 0,
                scale: scale,
                origin: new google.maps.Point(0, 0)
            };
        } else {
            return '<svg class="place-svg" viewBox="' + SVGViewBox + '" xmlns="http://www.w3.org/2000/svg" focusable="false"><path class="place-svg-path ' + (color ? 'fill-primary' : 'fill-white') + ' " d="' + SVGPath + '" ></path></svg>';
        }
    }


    /**
     * Will synch infobox with active results list items.  If there is a match in the results list, will activate results item.  If no match, then close the popup infobox
     **/
    function processInfoBox() {
        setTimeout(function () {															// need this timer to allow immediately subsequent map queries and retries to complete first
            var infoWindowStatus = $('.info-bubble-container').parent().css('display');
            if (typeof infoWindowStatus !== 'undefined') {
                if ($('.info-bubble-container').parent().css('display') === 'block') {
                    var infoBubblepoiId = $('.info-bubble').attr('data-poiId');
                    var $matchedResultsListingElement = $('.communityMap .map-results-listing #' + infoBubblepoiId + ':first');
                    if ($matchedResultsListingElement.length > 0) {								// if there is a match in the results list, make sure it is active
                        if (!$matchedResultsListingElement.hasClass('active')) {
                            $matchedResultsListingElement.addClass('active');
                        }
                    } else {																	// if no match, then close the popup infobox
                        infowindow.close();
                    }
                }
            }
        }, 600);
    }

    /**
     * Will remove the given markers from the map so that they are no longer displayed.
     *            Cannot assume we need to close the popup infobox since: 1) we may redisplay this marker with an immediately following map query or this popup is still be displayed due to another item in the results list that is the same POIId and is active
     **/
    function removeMarkers(markers) {
        var marker;

        for (var i = 0; i < markers.length; i++) {
            marker = markers[i];
            marker.setMap(null);
            google.maps.event.trigger(marker, 'marker-removed', {});
        }
    }

    /**
     * Removes all point of interest markers from the map and array.
     **/
    function removePOIMarkers() {
        removeMarkers(poiMarkers);
        poiResultsMap = {};
        poiMarkers = [];
    }

    /**
     * Removes all keyword markers from the map and array.
     **/
    function removeKeywordMarkers() {
        removeMarkers(keywordMarkers);
        keywordMarkers = [];
        $mapResultsListing.find('.place-type.keyword-search').remove();
        $mapResultsListing.find('.place.keyword-search.no-keyword-results').remove();
    }

    /**
     * Clears entire search including: selected pois, keyword typed in, and all markers on the map. Will even reset the view to be where it started.
     **/
    function clearSearch() {
        $noResults.addClass('shown');
        $mapResults.addClass('closed');
        $mapResultsWrapper.removeClass('results-opened');
        $mapResultsDisplayStatus.text(RESULTS_DISPLAY_CLOSED);

        if (!!$featuredPois) {
            $featuredPois.removeClass('active');
        }

        removePOIMarkers();
        removeKeywordMarkers();

        $poiSelect.find('.poi-choice input[type="checkbox"]').prop('checked', false);
        $keywordSearch.val('');

        gMap.setCenter(new google.maps.LatLng(lat, lng));
        gMap.setZoom(INITIAL_ZOOM_LEVEL);
    }

    function showKeywordResults(results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            for (var i = 0, place; place = results[i]; i++) {
                var keywordMarker = createMarker(place, null, true, KEYWORD_SEARCH_POI_ID);
                keywordMarkers.push(keywordMarker);
                placesIdMap[KEYWORD_SEARCH_POI_ID].push(keywordMarker);
            }

            var $listPlaceTypeHeader = $('<li class="place-type keyword-search" tabindex="0"><span class="name" title="' + $keywordSearch.val() + '">Search: ' + $keywordSearch.val() + '</span></li>');
            attachListingKeyHandler($listPlaceTypeHeader);
            $mapResultsListing.prepend($listPlaceTypeHeader);
            $mapResults.removeClass('closed');
            $mapResultsWrapper.addClass('results-opened');
            $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            $noResults.removeClass('shown');
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            if (!poiMarkers.length) {
                $noResults.addClass('shown');
            } else {
                $mapResultsListing.prepend($('<li class="place keyword-search no-keyword-results">No search results found.</li>'));
                $mapResultsListing.prepend($('<li class="place-type keyword-search"><span class="name" title="' + $keywordSearch.val() + '">Search: ' + $keywordSearch.val() + '</span></li>'));
            }
        }
    }

    /**
     * Shows the keyword search's results on the map.
     **/
    function getKeywordResults(keyword) {
        removeKeywordMarkers();
        placesIdMap[KEYWORD_SEARCH_POI_ID] = [];

        if (!!keyword) {
            runNearBySearch(keyword, null, true, showKeywordResults);
        }
    }

    /**
     * Show map marker information in the infowindow.
     **/
    function showMapMarkerInfo(marker, infowindowContent) {
        infowindow.setContent(infowindowContent);
        infowindow.open(gMap, marker);
    }

    /**
     * Scrolls given list item into view and adds necessary class name.
     **/
    function scrollItemToTop($this) {
        var top = $this.position();
        $mapResultsListing.find('li.place.active').removeClass('active');

        setTimeout(function () {
            $this.addClass('active');
            $('.info-bubble').attr('data-poiId', $this.attr('id'));
        }, 50);
        $mapResults.scrollTop(top.top);
    }

    /**
     * Add's a focus handler to the marker's list item so that it can popup the marker's info.
     **/
    function attachListingClickEvent($listItem, marker) {
        $listItem.on('click', function () {
            if ($listItem.hasClass('active')) {
                trackEvent(GA_EVENT_CATEGORY, 'poi-result-closed', GA_GENERIC_EVENT_LABEL);
                infowindow.close();
                google.maps.event.trigger(marker, 'hide-marker-info', {});
            } else {
                trackEvent(GA_EVENT_CATEGORY, 'poi-result-opened', GA_GENERIC_EVENT_LABEL);
                google.maps.event.trigger(marker, 'display-marker-info', {});
                setTimeout(function () {
                    $('.info-bubble').attr('data-poiId', $listItem.attr('id'));
                }, 100);
            }
        });
    }

    /**
     * Add's a key handler to the marker's list item so that a keyboard user can navigate up and down the results list.
     **/
    function attachListingKeyHandler($listItem) {
        $listItem.on('keydown', function (evt, poiId) {
            switch (evt.which) {
                case 40 :																						// check for  down arrow (40)
                    $(this).next().focus().click();																		// go to next item in list
                    evt.preventDefault();
                    break;

                case 38 :																						// check for up arrow (38)
                    $(this).prev().focus().click();																		// go to previous item in list
                    evt.preventDefault();
                    break;

                case 36 :																						// check for home key (36)
                    $('.map-results-listing .place:first').focus().click();												// go to top of list
                    evt.preventDefault();
                    break;

                case 35 :																						// check for end key (35)
                    $('.map-results-listing .place:last').focus().click();												// go to end of list
                    evt.preventDefault();
                    break;
            }
        });
    }

    /**
     * Adds the marker's info to the listing
     **/
    function addMarkerToListing(place, marker, icon, poiId, typeName) {
        var content = '<li class="active-background-primary place ' + poiId + '" id="' + place.place_id + '" tabindex="-1"><div class="place-arrow"></div><div class="place-icon">' + getPOIIcon(typeName, null, true) + '</div><div class="place-info-wrapper"><span class="place-name">' + place.name + '</span>';

        if (place.vicinity) {
            content = content + '<span class="place-address">' + place.vicinity + '</span>';
        } else {
            content = content + '<span class="place-address">' + place.formatted_address + '</span>';
        }

        var distanceRounded1Decimal = (Math.round(distanceCalc(place.geometry.location.lat(), lat, place.geometry.location.lng(), lng) * 10) / 10).toString();
        content = content + '<span class="place-distance">' + distanceRounded1Decimal + ((distanceRounded1Decimal === '1') ? ' mile' : ' miles') + '</span></div></li>';		// add distance to listing

        var $listItem;

        if ($mapResultsListing.find('.place.' + poiId).length) {
            $listItem = $(content);
            $mapResultsListing.find('.place.' + poiId + ':first').before($listItem);
        } else {
            $listItem = $(content).prependTo($mapResultsListing);
        }

        attachListingClickEvent($listItem, marker);
        attachListingKeyHandler($listItem);
        stickyFooter();

        return $listItem;
    }

    /**
     * Show map marker info
     **/
    function displayMarkerInfo(marker, infowindowContent) {
        showMapMarkerInfo(marker, infowindowContent);

        var intervalCount = 0,
            closeBtnInterval = setInterval(function () {
                var $infoWindowCloseBtn = $communityMap.find('.info-bubble .btn.close-btn');

                if ($infoWindowCloseBtn.length) {
                    $infoWindowCloseBtn.on('click', function () {
                        google.maps.event.trigger(marker, 'hide-marker-info', {});
                    });

                    clearInterval(closeBtnInterval);
                }

                //Let's not do this forever
                if (intervalCount > 50) {
                    clearInterval(closeBtnInterval);
                }

                intervalCount++;
            }, 20);
    }

    /**
     * Will create a marker with the given svg icon construction, when icon is null it'll create the default one using the primary color.
     **/
    function createMarker(place, icon, addToListing, poiId, typeName) {
        var placeLoc = place.geometry.location,
            markerIcon = getPOIIcon(null, mapPrimaryColor, false);

        //We assume that these are icons
        if (icon != null) {
            markerIcon = icon;
        }

        //Setup default value
        if (addToListing == null) {
            addToListing = true;
        }

        var marker = new google.maps.Marker({
            map: gMap,
            icon: markerIcon,
            position: placeLoc,
            draggable: false,
            title: place.name,
            zIndex: 1,
            optimized: false
        });

        var infowindowContent;

        if (place.vicinity) {
            infowindowContent = '<button class="btn close-btn color-primary">x</button><div class="place-info" data-poiId="' + poiId + '"><p class="place-name">' + place.name + '</p><p class="place-address">' + place.vicinity + '</p>';
        } else {
            infowindowContent = '<button class="btn close-btn color-primary">x</button><div class="place-info" data-poiId="' + poiId + '"><p class="place-name">' + place.name + '</p><p class="place-address">' + place.formatted_address + '</p>';
        }

        if (addToListing) {
            var distanceRounded1Decimal = (Math.round(distanceCalc(place.geometry.location.lat(), lat, place.geometry.location.lng(), lng) * 10) / 10).toString();
            infowindowContent = infowindowContent + '<p class="place-distance">' + distanceRounded1Decimal + ((distanceRounded1Decimal === '1') ? ' mile' : ' miles') + '</p></div>';		// add distance to popup info
        } else {
            infowindowContent = infowindowContent + '</div>';
        }

        google.maps.event.addListener(marker, 'click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'poi-marker-clicked', GA_GENERIC_EVENT_LABEL);
            displayMarkerInfo(marker, infowindowContent);
        });

        if (addToListing) {
            var $listItem = addMarkerToListing(place, marker, markerIcon, poiId, typeName);

            google.maps.event.addListener(marker, 'marker-removed', function () {
                if (poiId) {
                    $listItem.siblings('.place-type.' + poiId).remove();
                }
                var placeId = $listItem.prop('id');
                delete placesIdMap[poiId][placeId];
                $listItem.remove();
                stickyFooter();
            });

            google.maps.event.addListener(marker, 'marker-shown', function () {
                attachListingClickEvent($listItem, marker);
                stickyFooter();
            });

            google.maps.event.addListener(marker, 'click', function () {
                scrollItemToTop($listItem);
            });

            google.maps.event.addListener(marker, 'display-marker-info', function () {
                displayMarkerInfo(marker, infowindowContent);
                $mapResultsListing.find('li.place.active').removeClass('active');
                $listItem.addClass('active');
                $('.info-bubble').attr('data-poiId', $listItem.attr('id'));
            });

        }

        google.maps.event.addListener(marker, 'hide-marker-info', function () {
            infowindow.close();

            if (addToListing) {
                $mapResultsListing.find('li.place.active').removeClass('active');
            }
        });

        return marker;
    }

    /**
     * Process the google places response that's been forwarded from the webservice.
     **/
    function processPlacesResponse(poiId, keyword, results, status, icon, typeName) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            if (results.length) {
                var placesToKeep = [];
                poiResultsMap[poiId] = {markers: []};
                if (!placesIdMap[poiId]) {
                    placesIdMap[poiId] = {};
                }

                for (var i = 0; i < results.length; i++) {
                    var result = results[i],
                        placeId = result.place_id,
                        types = result.types,
                        isRealBeach;
                    // Beach Place type from googlemaps is not reliable. Use text search and filter response
                    ((keyword == 'beach') && ((types.indexOf('park') > -1) || (types.indexOf('natural_feature') > -1))) ? (isRealBeach = true) : (isRealBeach = false);

                    if ((keyword != 'beach') || (isRealBeach)) {
                        if (!placesIdMap[poiId][placeId]) {
                            placesIdMap[poiId][placeId] = createMarker(result, icon, true, poiId, typeName);
                        }
                        poiResultsMap[poiId].markers.push(placesIdMap[poiId][placeId]);
                        poiMarkers.push(placesIdMap[poiId][placeId]);
                        placesToKeep.push(placeId);
                    }
                }

                var placeIdsArr = Object.keys(placesIdMap[poiId]),
                    placesMap = placesIdMap[poiId];

                for (var i = 0; i < placeIdsArr.length; i++) {
                    var placeId = placeIdsArr[i];
                    if (placesToKeep.indexOf(placeId) < 0) {
                        removeMarkers([placesMap[placeId]]);
                        delete placesMap[placeId];
                    }
                }

                if ($mapResultsListing.find('.place-type.' + poiId).length) {
                    $mapResultsListing.find('.place-type.' + poiId).remove();
                }
                var $listPlaceTypeHeader = $('<li id="place-type-' + poiId + '" class="place-type ' + poiId + '" tabindex="0"><span class="name">' + typeName + '</span><span class="listing-border"></span></li>');
                attachListingKeyHandler($listPlaceTypeHeader);
                $mapResultsListing.find('.place.' + poiId + ':first').before($listPlaceTypeHeader);
            } else {
                $mapResultsListing.find('.place-type.' + poiId).remove();
                if (poiResultsMap[poiId] != null) {
                    removeMarkers(poiResultsMap[poiId].markers);
                }
                delete poiResultsMap[poiId];
            }
        } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            $mapResultsListing.find('.place-type.' + poiId).remove();

            if (poiResultsMap[poiId] != null) {
                removeMarkers(poiResultsMap[poiId].markers);
            }
            delete poiResultsMap[poiId];
        }

        //We are lazy, so let's just check each time
        if (poiMarkers.length > 0 || keywordMarkers.length > 0) {
            $mapResults.removeClass('closed');
            $mapResultsWrapper.addClass('results-opened');
            $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            $noResults.removeClass('shown');
        } else {
            $mapResults.removeClass('closed');
            $mapResultsWrapper.addClass('results-opened');
            $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
            $noResults.addClass('shown');
        }
        processInfoBox();		// determine if we need to close the popup info box or activate an item in the updated results list
    }

    /**
     * Processes the places queue and will try to load that places info once more.
     **/
    function processRetryQueue() {
        if (placesRetryQueue.length > 0) {
            setTimeout(function () {
                var placeInfo = placesRetryQueue.shift();
                runNearBySearch(placeInfo.keyword, placeInfo.type, false, placeInfo.successCallback);
                processRetryQueue();
            }, 500);
        }
    }

    /**
     * Runs the near by search with google's api.
     */
    function runNearBySearch(keyword, type, tryAgain, successCallback) {
        var request = {
            bounds: gMap.getBounds(),
            keyword: keyword
        };

        if (!!type) {
            request.type = type;
        }

        var service = new google.maps.places.PlacesService(gMap);
        service.nearbySearch(request, function (results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT && tryAgain) {
                placesRetryQueue.push({
                    keyword: keyword,
                    type: type,
                    successCallback: successCallback
                });
            } else if (status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT) {
                console.error('Over google places service query limit.');
            } else {
                successCallback(results, status);
            }
        });
    }

    /**
     * Loads places given the keyword and type using our google places forwarding api. Icon is passed along in marker creation.
     **/
    function loadPlaces(poiId, keyword, type, displayText, icon, tryAgain) {
        runNearBySearch(keyword, type, tryAgain, function (results, status) {
            processPlacesResponse(poiId, keyword, results, status, icon, displayText);
        });
    }

    /**
     * Updates the points of interest being shown. Is throttled so that if someone selects a bunch of choices quickly, we don't end up doing requests we won't use or something.
     **/
    function updatePOIsShown(updateExistingResults, showNoResults) {
        initSearchableMap();
        if (!updateExistingResults) {
            updateExistingResults = false;
        }

        clearTimeout(poiUpdateThrottle);

        poiUpdateThrottle = setTimeout(function () {
            //Let's remove only non-selected markers
            var $notSelectedPOIs = $poiSelect.find('.poi-choice:not(.poi-group-choice) input[type="checkbox"]:not(:checked)');
            if ($notSelectedPOIs.length > 0) {
                $notSelectedPOIs.each(function () {
                    var $this = $(this),
                        poiId = $this.prop('id');

                    if (!!poiResultsMap[poiId]) {
                        removeMarkers(poiResultsMap[poiId].markers);
                        delete poiResultsMap[poiId];
                    }
                });
            }

            //Now let's show selected markers that aren't already shown
            var $selectedPOIs = $poiSelect.find('.poi-choice:not(.poi-group-choice) input[type="checkbox"]:checked');
            if ($selectedPOIs.length) {
                poiMarkers = [];

                $selectedPOIs.each(function () {
                    var $this = $(this),
                        poiId = $this.prop('id');

                    //If we have the poi, it's already showing.
                    if (!poiResultsMap[poiId]) {
                        var poiLabel = $this.siblings('label').text();
                        trackEvent(GA_EVENT_CATEGORY, 'poi-selected', poiLabel);

                        loadPlaces(poiId, $this.data('keyword'), $this.data('type'), poiLabel, getPOIIcon(poiLabel, mapPrimaryColor), true);
                        processRetryQueue();
                    } else if (!!poiResultsMap[poiId] && updateExistingResults) {
                        var poiLabel = $this.siblings('label').text();

                        loadPlaces(poiId, $this.data('keyword'), $this.data('type'), poiLabel, getPOIIcon(poiLabel, mapPrimaryColor), true);
                        processRetryQueue();
                    } else if (!!poiResultsMap[poiId]) {
                        poiMarkers = poiMarkers.concat(poiResultsMap[poiId].markers);
                    }
                });
            } else if (!keywordMarkers.length && !!showNoResults) {
                //We need to check for empty results and show the no results message if so.
                $mapResults.removeClass('closed');
                $mapResultsWrapper.addClass('results-opened');
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
                $noResults.addClass('shown');
            }
            processInfoBox();		// determine if we need to close the popup info box or activate an item in the updated results list
        }, POI_UPDATE_TIMEOUT);
    }

    /**
     * Build a generic point of interest choice. We add tabindex so that firefox doesn't lose focus when label is clicked.
     **/
    function buildPOIChoice(keyword, type, color, display, $target) {
        var html = '<li class="poi-choice" role="option" ><input id="poi-' + poiCount + '" type="checkbox" data-keyword="' + keyword + '" data-type="' + type + '" tabindex="-1" /><div class="checkbox-indicator"></div><div class="poi-icon">' + getPOIIcon(display, color, true) + '</div><label for="poi-' + poiCount + '">' + display + '</label></li>';
        poiCount++;
        return $(html).appendTo($target);
    }

    /**
     * Build a group point of interest choice. We add tabindex so that firefox doesn't lose focus when label is clicked.
     **/
    function buildGroupPOIChoice(display, color, $target) {
        var html = '<li class="poi-choice poi-group-choice" role="option" ><input id="poi-' + poiCount + '" type="checkbox"  tabindex="-1" /><div class="checkbox-indicator"></div><div class="poi-icon">' + getPOIIcon(display, color, true) + '</div><label for="poi-' + poiCount + '">' + display + '</label></li>';
        poiCount++;
        return $(html).appendTo($target);
    }

    /**
     * Builds out the set of point of interest choices in the ui. Attaches appropriate event handlers and handles the groupings.
     **/
    function buildPOIChoices(choices, $target) {
        $.each(choices, function (idx, newPOI) {
            if (newPOI.isGroup) {
                var $groupPOI = buildGroupPOIChoice(newPOI.display, mapPrimaryColor, $target);

                var subchoices = newPOI.subchoices,
                    $subchoices = $();

                if (subchoices != null && subchoices.length) {
                    var $subchoicesBox = $('<ul class="poi-subchoices" role="listbox" aria-label="' + newPOI.display + ' subgroup"></ul>').insertAfter($groupPOI);

                    $.each(subchoices, function (subIdx, newSubPOI) {
                        var $newSubchoice = buildPOIChoice(newSubPOI.keyword, newSubPOI.type, mapPrimaryColor, newSubPOI.display, $subchoicesBox);
                        $subchoices = $subchoices.add($newSubchoice);

                        $newSubchoice.on('click', 'input[type="checkbox"]', function () {
                            var $input = $(this),
                                checked = $input.prop('checked');

                            var $groupCheckbox = $groupPOI.find('input[type="checkbox"]'),
                                groupChecked = $groupCheckbox.is(':checked');

                            if (!checked && groupChecked) {
                                $groupCheckbox.prop('checked', false);
                            }

                            if (checked && !groupChecked && $subchoices.find('input[type="checkbox"]:checked').length === $subchoices.length) {
                                $groupCheckbox.prop('checked', true);
                            }

                            updatePOIsShown(false, true);
                        });
                    });
                    $('.poi-choices-box > .poi-subchoices').wrapAll('<li role=\'option\'></li>');			// wrap ul subchoice group with li element to fit correctly in choices-box ul list
                }

                //Group POI Handler
                $groupPOI.on('click', 'input[type="checkbox"]', function () {
                    var $input = $(this),
                        checked = $input.prop('checked');

                    $subchoices.each(function (idx, subchoice) {
                        var $subchoiceInput = $(subchoice).find('input[type="checkbox"]');

                        if ($subchoiceInput.prop('checked') !== checked) {
                            $subchoiceInput.click();
                        }
                    });

                    updatePOIsShown(false, true);
                });
            } else {
                var $newChoice = buildPOIChoice(newPOI.keyword, newPOI.type, getPOIIcon(newPOI.display, mapPrimaryColor, true), newPOI.display, $target);
                $newChoice.on('click', 'input[type="checkbox"]', function () {
                    updatePOIsShown(false, true);
                });
            }

            $poiSelect.on('keydown', '.poi-choice input', function (evt) {
                switch (evt.which) {
                    case 40 : 																						// check for  down arrow (40)
                        $('.poi-choice input#poi-' + (parseInt(this.id.split('-')[1], 10) + 1).toString()).focus(); 	// go to next input field
                        evt.preventDefault();
                        break;

                    case 38 :																						// check for up arrow (38)
                        $('.poi-choice input#poi-' + (parseInt(this.id.split('-')[1], 10) - 1).toString()).focus();	// go to previous input field
                        evt.preventDefault();
                        break;

                    case 36 :																						// check for home key (36)
                        $('.poi-choice input:first').focus();														// go to top of list
                        evt.preventDefault();
                        break;

                    case 35 :																						// check for end key (35)
                        $('.poi-choice input:last').focus();														// go to end of list
                        evt.preventDefault();
                        break;

                    case 9    : 																						// check for tab/shift tab (9)
                        $(this).parents('.poi-select').removeClass('shown');										// collapse drop down
                        break;
                }
            });
        });
    }

    /**
     * Initializes the search ui. Will attach click handlers to buttons, and helps setup the custom dropdown ui for the pois.
     **/
    function initSearch() {
        var $poiChoicesBox = $poiSelect.find('.poi-choices-box'),
            $submitBtn = $mapSearch.find('.btn.btn-search');

        $resetSearchBtn.on('click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'reset-btn-press', GA_GENERIC_EVENT_LABEL);
            clearSearch();
        });

        function openPOISelection(evt) {
            $('.poi-select').addClass('shown').find('poi-choices-box').css('visibility', 'visible');		// expand the drop down box and restore visibility
            var $firstChoiceChecked = $('.poi-select').find('input:checked:first');							// find the first selected option
            if ($firstChoiceChecked.length === 1) {
                $firstChoiceChecked.focus();
                if ($firstChoiceChecked.parent().parent().hasClass('poi-subchoices')) {						// if first selected item is a POI subchoice, set scroll so the POI group containing the selected item appears at the top (both group and subchoice will then be visible)
                    $poiChoicesBox.scrollTop(
                        $firstChoiceChecked.parent().parent().offset().top 									// top coordinate of the first checked element we want to end up near top of final scrolled position
                        - $poiChoicesBox.offset().top														// top coordinate of top of scroll container.  the difference is their "delta"
                        + $poiChoicesBox.scrollTop()														// amount required to fully scroll the container.  We only want to scroll the first checked element to top, so need to subtract the "delta"
                        - 40);																				// back off (subtract) just a few more pixels (40) from the amount to be scrolled so that we can still see a portion of the preceding element
                } else {
                    $poiChoicesBox.scrollTop($firstChoiceChecked.offset().top - $poiChoicesBox.offset().top + $poiChoicesBox.scrollTop() - 15);									// scroll amount setting = scroll element to top, but leave some amount short so we see bottom of previous element (hint for user)
                }
            } else {
                $('.poi-choice input:first').focus();														// if there are no selections, then move focus to first item in the POI list of choices
                $poiChoicesBox.scrollTop(0);
            }
        }

        $poiSelect.on('click', '.poi-select-display', function (evt) {
            if ($poiSelect.hasClass('shown')) {
                $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden');    // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
            } else {
                openPOISelection(evt);
                evt.stopPropagation();
            }
        });

        $poiSelect.on('keypress', '.poi-select-display', function (evt) {
            if ((evt.which === 13) || (evt.which === 32)) {							// enter or space key toggles poi list display
                openPOISelection(evt);
                evt.preventDefault();
            } else {
                $(this).parents('.poi-select').removeClass('shown').find('poi-choices-box').css('visibility', 'hidden');		// collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
            }
        });

        $poiSelect.on('keydown', '.poi-select-display', function (evt) {				// down arrow opens up the poi display and moves cursor to item in list
            if (evt.which === 40) {
                openPOISelection(evt);
                evt.preventDefault();
            }
        });

        $poiSelect.on('click', '.poi-choices-box', function (evt) {
            evt.stopPropagation();
        });

        $html.on('click', '*:not(.communityMap .poi-select, .communityMap .poi-select *)', function () {
            $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden');    // collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
        });

        $poiSelect.on('blur', function () {
            $poiSelect.removeClass('shown').find('poi-choices-box').css('visibility', 'hidden');	// collapse drop down box and remove visibility so screen readers do not read from it if hovered over it
        });

        $keywordSearch.on('keydown', function (evt) {
            initSearchableMap();
            if (evt.keyCode === 13) {
                getKeywordResults($keywordSearch.val());
                updatePOIsShown(false, true);
            }
        });

        $keywordSearch.on('focusout', function () {
            initSearchableMap();
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(false, true);
        });

        $submitBtn.on('click', function () {
            trackEvent(GA_EVENT_CATEGORY, 'search-btn-press', GA_GENERIC_EVENT_LABEL);

            initSearchableMap();
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(false, true);
        });

        buildPOIChoices(mapConfig, $poiChoicesBox);
    }

    /**
     * Will initialize the custom map controls for the ui.
     **/
    function initMapControls() {
        var $centerMapBtn = $('<div class="center-map-btn"><img class="center-icon" src="/assets/images/map/target.png" alt="Re-Center Icon" /></div>');
        $centerMapBtn.on('click', function (evt, track) {
            if (!track || track) {
                trackEvent(GA_EVENT_CATEGORY, 'center-btn-press', GA_GENERIC_EVENT_LABEL);
            }
            gMap.setCenter({lat: lat, lng: lng});
        });

        gMap.controls[google.maps.ControlPosition.BOTTOM_CENTER].push($centerMapBtn.get(0));
    }

    /**
     * Updates map results for both places of interest and keyword search
     **/
    function updateMapResults() {
        clearTimeout(mapViewChangeThrottle);
        mapViewChangeThrottle = setTimeout(function () {
            getKeywordResults($keywordSearch.val());
            updatePOIsShown(true, false);
        }, MAP_VIEW_CHANGE_THROTTLE_TIME);
    }

    /**
     * Initializes the results tab, allowing it to be shown or hidden.
     */
    function initResultsTab() {
        var $resultsToggle = $mapResults.find('.map-results-toggle');

        $resultsToggle.on('click', function (evt) {
            $mapResults.toggleClass('closed');
            $mapResultsWrapper.toggleClass('results-opened');
            if ($mapResultsWrapper.hasClass('results-opened')) {
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_OPENED);
                $('.place-type').attr('tabindex', '0');
            } else {
                $mapResultsDisplayStatus.text(RESULTS_DISPLAY_CLOSED);
                $('.place-type').attr('tabindex', '-1');
            }
            evt.preventDefault();
        });

        $noResults.addClass('shown');
    }

    function buildFeaturedPOI(featuredPOI) {
        var poiSVG = getPOIIcon(featuredPOI.display, mapPrimaryColor, true);
        return '<div class="featured-place active-background-primary background-transparent" tabindex="0" role="button" aria-pressed="false"><div class="place-icon">' + poiSVG + '</div><div class="place-name">' + featuredPOI.display + '</div></div>';
    }

    function initFeaturedPOIS() {
        if (featuredPOIs.length) {
            var $featuredPOIContainer = $('.communityMap .map-featured-places .featured-places-list'),
                $selectPOIs = $poiSelect.find('.poi-choice input[type="checkbox"]');

            featuredPOIs.forEach(function (featuredPOI) {
                var featuredPOIHTML = buildFeaturedPOI(featuredPOI),
                    $featuredPOI = $(featuredPOIHTML).appendTo($featuredPOIContainer),
                    $associatedPOI = $selectPOIs.filter(function () {
                        return $(this).data('keyword') === featuredPOI.keyword;
                    }),
                    ignoreAssociatedClick = false;

                $featuredPOI.on('click', function (evt) {
                    $featuredPOI.toggleClass('active');
                    $featuredPOI.attr('aria-pressed', ($featuredPOI.attr('aria-pressed') !== 'true'));
                    ignoreAssociatedClick = true;
                    $associatedPOI.click();
                    if (!$featuredPOI.hasClass('active')) {					// if we just toggled this POI to inactive, then determine if we need to close the popup info box or activate another item in the results list
                        processInfoBox();
                    }
                });

                $featuredPOI.on('keydown keypress', function (evt) {
                    if ((evt.which === 13) || (evt.which === 32)) {					// check for enter or space key pressed
                        $featuredPOI.click();
                        evt.preventDefault();
                    }
                });

                $associatedPOI.on('click', function () {
                    if (!ignoreAssociatedClick) {
                        $featuredPOI.toggleClass('active');
                        $featuredPOI.attr('aria-pressed', ($featuredPOI.attr('aria-pressed') !== 'true'));
                        if (!$featuredPOI.hasClass('active')) {					// if we just toggled this POI to inactive, then determine if we need to close the popup info box or activate another item in the results list
                            processInfoBox();
                        }
                    } else {
                        ignoreAssociatedClick = false;
                    }
                });

            });
            return $featuredPOIContainer.find('.featured-place');
        }
    }

    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    function convertColorsToRGB() {
        if (mapAccentColor.indexOf('#') >= 0) {
            var accentRGB = hexToRgb(mapAccentColor);
            if (accentRGB !== null) {
                mapAccentColor = 'rgb(' + accentRGB.r + ',' + accentRGB.g + ',' + accentRGB.b + ')';
            }
        }

        if (mapPrimaryColor.indexOf('#') >= 0) {
            var primaryRGB = hexToRgb(mapPrimaryColor);
            if (accentRGB !== null) {
                mapPrimaryColor = 'rgb(' + primaryRGB.r + ',' + primaryRGB.g + ',' + primaryRGB.b + ')';
            }
        }
    }

    /**
     * Initializes everything from the map to the search ui and fills some variables we need later on. Should only get ran once.
     **/
    function initSearchableMap() {
        if (initializedSearchable) {
            return;
        }

        initializedSearchable = true;

        var mapOptions = {
            center: new google.maps.LatLng(lat, lng),
            zoom: INITIAL_ZOOM_LEVEL,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        //This will help ensure that we don't accidentally lose any event listeners
        document.getElementById('communityMap').innerHTML = '';
        gMap = new google.maps.Map(document.getElementById('communityMap'), mapOptions);
        google.maps.event.addListener(gMap, 'zoom_changed', updateMapResults);
        google.maps.event.addListener(gMap, 'dragend', updateMapResults);
        google.maps.event.addListener(gMap, 'resize', updateMapResults);

        communityMarker = createMarker({
            geometry: {
                location: {
                    lat: lat,
                    lng: lng
                }
            },
            name: $communityMap.data('community-name'),
            formatted_address: $communityMap.data('formatted-address')
        }, getPOIIcon(null, mapAccentColor, false), false, -1, null);

        google.maps.event.addListener(communityMarker, 'click', function () {
            $mapResultsListing.find('li.place.active').removeClass('active');
        });

        infowindow = new InfoBubble(DEFAULT_INFO_BUBBLE_OPTIONS);
        infowindow.setMaxHeight(45);

        initMapControls();
    }

    function init() {
        if (initialized) {
            return;
        }

        initialized = true;

        convertColorsToRGB();

        lat = $communityMap.data('latitude');
        lng = $communityMap.data('longitude');


        var communityMappable = $communityMap.data('community-mappable');
        var searchAddress = $communityMap.data('formatted-address');
        if (communityMappable) {
            var communityName = $communityMap.data('community-name');
            communityName = communityName.split('&').join('%26');
            searchAddress = communityName + ', ' + searchAddress;
        }

        document.getElementById('communityMap').innerHTML = '<iframe title="Explore the Area Map" frameborder="0" style="border:0" allowfullscreen src="https://www.google.com/maps/embed/v1/place?key=' + $communityMap.data('key') + '&language=en' + '&q=' + searchAddress + '"></iframe>';

        initSearch();
        initResultsTab();
        $featuredPois = initFeaturedPOIS();
    }

    init();
}

window.addEventListener('load', function () {
    initInteractiveMap();
});

if (!!window.initInteractiveMapOnLoad) {
    initInteractiveMap();
}